document.addEventListener("DOMContentLoaded", function() {
  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  }

  function updateAll(row) {
    const variantId = row.dataset.vid;
    const sellingPlan = row.dataset.plan || "";

    // Guard: skip if no variant ID
    if (!variantId) {
      console.warn('Missing data-vid on row:', row);
      return;
    }

    const variantInput = document.querySelector('input[name="id"].product-variant-id');
    if (variantInput) {
      variantInput.value = variantId;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    let planInput = document.querySelector('input[name="selling_plan"]');
    if (!planInput && variantInput) {
      planInput = document.createElement("input");
      planInput.type = "hidden";
      planInput.name = "selling_plan";
      variantInput.closest("form").appendChild(planInput);
    }
    if (planInput) planInput.value = sellingPlan;

    document.querySelectorAll('.sub-row').forEach(function(r) {
      const p = parseInt(r.dataset.price);
      const c = parseInt(r.dataset.compare);
      const box = r.querySelector('.price-display');

      if (!box) return;

      if (r.classList.contains('highlight-option')) {
        const monthlyPrice = p / 3;
        box.innerHTML = (c && c > p) ?
          `<s>${formatMoney(c)}</s> <strong>${formatMoney(monthlyPrice)} per box</strong>` :
          `<strong>${formatMoney(monthlyPrice)}/mo</strong>`;
      } else {
        const suffix = r.classList.contains('one-time-option') ? '' : '/mo';
        box.innerHTML = (c && c > p) ?
          `<s>${formatMoney(c)}</s> <strong>${formatMoney(p)}${suffix}</strong>` :
          `<strong>${formatMoney(p)}${suffix}</strong>`;
      }
    });

    // Update URL
    const url = `?variant=${variantId}${sellingPlan ? '&selling_plan=' + sellingPlan : ''}`;
    window.history.replaceState({}, '', url);

    // Auto-add to cart for one-time option
    if (row.classList.contains('one-time-option')) {
      const atcButton = document.querySelector('.product-form__submit');
      if (atcButton) {
        setTimeout(() => {
          atcButton.click();
        }, 100);
      }
    }
  }

  // Radio change listener
  document.querySelectorAll('input[name="purchase_option"]').forEach(radio => {
    radio.addEventListener("change", function() {
      updateAll(this.closest('.sub-row'));
    });
  });

  // Row click listener
  document.querySelectorAll('.sub-row').forEach(row => {
    row.addEventListener('click', function(e) {
      const radio = this.querySelector('input[name="purchase_option"]');
      if (radio && e.target !== radio) {
        radio.checked = true;
        updateAll(this);
      }
    });
  });

  // Init on page load with whichever radio is pre-checked
  const checkedRadio = document.querySelector('input[name="purchase_option"]:checked');
  if (checkedRadio) updateAll(checkedRadio.closest('.sub-row'));
});